import { ArrowUpRight, Facebook, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="cpmc-footer-section"
      className="border-t border-cream/10 bg-ink py-12 text-cream"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-5 sm:px-8 md:flex-row md:items-center">
        <div>
          <p className="font-display text-lg font-bold">
            CPMC <span className="text-sun">·</span> Québec
          </p>
          <p className="mt-2 max-w-sm text-sm text-cream/50">
            Formation Certified Personal Medicine Coach de Pat Deegan & Associates.
            Première cohorte francophone — octobre 2026.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <a
            href="mailto:info@cpmc-quebec.ca"
            data-testid="cpmc-footer-link-email"
            className="group flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-cream/70 transition-colors hover:text-sun"
          >
            <Mail className="h-3.5 w-3.5" />
            info@cpmc-quebec.ca
          </a>
          <a
            href="https://www.patdeegan.com/cpmc"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cpmc-footer-link-patdeegan"
            className="group flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-cream/70 transition-colors hover:text-sun"
          >
            patdeegan.com/cpmc
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <a
            href="https://www.commongroundprogram.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cpmc-footer-link-commonground"
            className="group flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-cream/70 transition-colors hover:text-sun"
          >
            commongroundprogram.com
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <a
            href="https://www.facebook.com/patdeegan.pda/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cpmc-footer-link-facebook"
            className="group flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-cream/70 transition-colors hover:text-sun"
          >
            <Facebook className="h-3.5 w-3.5" />
            Facebook — Pat Deegan
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </div>
      <div className="mx-auto mt-10 max-w-7xl border-t border-cream/10 px-5 pt-6 sm:px-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-cream/40">
          © 2026 — La Médecine Personnelle : ce que nous faisons pour aller mieux et le rester.
        </p>
      </div>
    </footer>
  );
}
